import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';

import DmtIcon from 'Components/DashboardIcon/DmtIcon';
import { LOGOUT } from 'ConstComponents';
import { Container, Paper, IconButton } from '@material-ui/core';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { SelectUserMorePayOnBoarding as SELECT_USER_MORE_PAY_ONBORDING } from 'Components/Api/UsersApi';
import HOCLoader from 'Components/Loader/HOCLoader';
import { useHistory } from 'react-router';
export const IndexMorePay = () => {
    const history = useHistory();

    const [loadingOpen, setLoadingOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [severity, setSeverity] = useState('success');
    const classes = commonStyle();
    const CustomContainer = HOCLoader(Container);

    const SelectUserOnBoarding = async () => {
        const response = await SELECT_USER_MORE_PAY_ONBORDING();

        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
        }
        let data = JSON.parse(response.data);
        if (data.Message.toLowerCase() === 'OpenOnboarding'.toLowerCase()) {
            history.push('/MP_UserOnboarding');
            return;
        } else if (data.Message.toLowerCase() === 'OpenOTP'.toLowerCase()) {
            let param = {
                MerchantCode: data.MorePayMerchantCode
            };

            history.push('/MP_EKYOTP', param);
            return;
        }
    };

    useEffect(() => {
        SelectUserOnBoarding();
    }, []);

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        ></CustomContainer>
    );
};
